// Module
var code = "<div>\n    <!-- <button ng-click=\"$ctrl.doLog()\">LOG</button> -->\n    <div id=\"lastLocationMinimap\"></div>\n</div>\n";
// Exports
module.exports = code;